import { Background } from '../types/background';

export const customBackground: Background = {
  id: 'custom',
  name: '自定义背景',
  description: '创建您自己的自定义背景。',
  'skill proficiencies': [],
  features: [],
  equipment: []
}; 